var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlow = function SvgFlow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080A11",
    fillRule: "evenodd",
    d: "M17.39 3.25c1.39 0 3.174.116 4.407 1.334.783.773 1.453 1.907 1.453 3.416s-.67 2.643-1.453 3.416c-1.233 1.218-3.018 1.334-4.406 1.334H5.424c-.62 0-1.115.024-1.542.19-1.004.39-2.132 1.282-2.132 3.06s1.128 2.67 2.132 3.06c.427.166.922.19 1.542.19h10.674A2.998 2.998 0 0 1 22 20a3 3 0 0 1-5.902.75H5.424c-.61 0-1.366-.013-2.085-.292C1.98 19.931.25 18.605.25 16s1.731-3.93 3.089-4.458c.72-.28 1.475-.292 2.085-.292H17.39c1.406 0 2.596-.156 3.351-.901.563-.556 1.008-1.324 1.008-2.349s-.445-1.793-1.008-2.349c-.755-.745-1.945-.901-3.351-.901H4.5a.75.75 0 0 1 0-1.5zM19 18.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
    clipRule: "evenodd"
  })));
};
export default SvgFlow;